module.exports = __webpack_public_path__ + "static/img/mh.6d60cee3.svg";